export default [
  // {
  //   path: '/cameras',
  //   name: 'cameras',
  //   component: () => import('@/views/cameras/CamerasMain.vue'),
  // },
  // {
  //   path: '/cameras/create',
  //   name: 'cameras-create',
  //   component: () => import('@/views/cameras/CamerasCreate.vue'),
  //   meta: {transitionName: 'zoom'},
  // },
  // {
  //   path: '/cameras/:id',
  //   name: 'cameras-edit',
  //   component: () => import('@/views/cameras/CamerasEdit.vue'),
  //   meta: {transitionName: 'slide'},
  // },
];
